import getByUrl from './helper/getByUrl';
import getShortFormVideoTopTracks, {
  IProps,
} from 'url-constructors/ShortFormVideo/getShortFormVideoTopTracks';

interface IShortFormVideoTopTracksInterceptionData {
  entityIds: string[];
  entityType: 'artist' | 'track';
  metricType: 'views' | 'creations';
  limit: number;
  offset: number;
  countryIds: string[];
}

const shortFormVideoTopTracksInterceptor = async (
  input: RequestInfo /* eslint-disable-line */,
  init: RequestInit | undefined /* eslint-disable-line */,
  interceptionData: IShortFormVideoTopTracksInterceptionData
): Promise<Response> => {
  const {
    entityIds,
    entityType,
    metricType,
    limit,
    offset,
    countryIds,
  } = interceptionData;
  const options: IProps = {
    entityIds,
    limit,
    offset,
    entityType,
    metricType,
    countryIds,
  };

  const apiUrl: string = getShortFormVideoTopTracks(options);

  try {
    const topTracksData = await getByUrl<any[]>(apiUrl);

    return new Response(
      JSON.stringify({
        topTracksData,
      })
    );
  } catch (error) {
    return new Response(JSON.stringify({ reason: new Error(error as any) }));
  }
};

export default shortFormVideoTopTracksInterceptor;
